module.exports = __webpack_public_path__ + "static/epc-logo-6dfecb67cef45ee5c6eea3d8b738f2d6.svg";